<template>
    <div>
         <div class="columns">
             <div class="column is-10">
                <h3 class="is-size-4 mb-4">Reporte de pacientes a la fecha</h3>
             </div>
             <div class="column is-2">
                 <button-export-report-patient v-if="!loading"></button-export-report-patient>         
             </div>
          </div>                
         <loader v-if="loading"></loader>
         <div class="table-container">
            <table v-if="!loading"  ref="tablePatient" class="table is-bordered is-narrow is-fullwidth">
                <thead>
                    <th class="col-header">Establecimiento</th>
                    <th class="col-header">Categoría</th>
                    <th class="col-header">Subcategoría</th>
                    <th class="col-header">Positivos</th>
                    <th class="col-header">Sospechas</th>
                    <th class="col-header">Negativos</th>
                    <th class="col-header">Total</th>
                </thead>
                <tbody>
                    <fragment v-for="(stablishment,index) in data" :key="index">
                        <tr>
                            <td :rowspan="countRowsStablishment(stablishment)"> {{stablishment.name}} </td>            
                        </tr>
                        <fragment v-for="(categoria,index) in stablishment.categorizations" :key="index">
                            <tr>
                                <td :rowspan="categoria.subcats.length+1"> {{categoria.name}}</td>
                            </tr>
                            <fragment  v-for="(subcat,index) in categoria.subcats" :key="index">
                                <tr>
                                    <td> {{subcat.name}}</td>
                                    <td> {{subcat.positives}}</td>
                                    <td> {{subcat.suspect}}</td>
                                    <td> {{subcat.negatives}}</td>
                                    <td> {{subcat.total}}</td>
                                </tr>
                            </fragment>
                        </fragment>
                        <tr class="col-subheader">
                            <td colspan="3"> <b>TOTAL ESTABLECIMIENTO</b> </td>
                        
                            <td > {{stablishment.positives}}</td>
                            <td> {{stablishment.suspect}}</td>
                            <td> {{stablishment.negatives}}</td>
                            <td width="100"> {{stablishment.total}}</td>
                        </tr>
                    </fragment>
                    <tr class="col-header">
                        <td colspan="3"><b>TOTAL</b></td>
                        <td> {{total.positives}}</td>
                        <td> {{total.suspect}}</td>
                        <td> {{total.negatives}}</td>
                        <td> {{total.total}}</td>
                    </tr>
                </tbody>
            </table>        
         </div>
    </div>
</template>
<script>
import { BedFindByStablishmentSubCatId } from '../../services/beds'
import { CategorizationFindByStablishmentId } from '../../services/categorization';
import { GetAllStablishment } from '../../services/stablishment'
import { SubCategorizationFindByCategorizationId } from '../../services/subCategorization';
import { Fragment } from "vue-fragment";
import ButtonExportReportPatient from '../beds/ButtonExportReportPatient';
import Loader from "./../../components/general/Loader"
import { eventBus } from '../../main';
export default {
    props:['stablishment_id'],
    components: {
        Fragment,
        ButtonExportReportPatient,
        Loader
    },
    data(){
            return{
            listStablishments:[],                                    
            listBeds:[],
            loading: true,            
            data:[],
            total: {
                total: 0,
                positives: 0,
                negatives: 0,
                suspect: 0
            }
        }
    },
    mounted(){
        this.chargeData();
    },
    methods:{
        // countRowsCategorization(stablishment, categorization) {
        //     let totalRows = 0;
        //     totalRows += stablishment.categorizations.length;
        //     stablishment.categorizations.forEach(cat => {
        //         totalRows += cat.subcats.length;
                
        //     });

        //     return totalRows;
        // },
        countRowsStablishment(stablishment) {
            let totalRows = 0;
            totalRows += stablishment.categorizations.length;
            stablishment.categorizations.forEach(cat => {
                totalRows += cat.subcats.length;
            });
            return totalRows + 1;
        },
        async chargeData(){
            this.listStablishments=await GetAllStablishment(this.$http);
            if(this.stablishment_id){
                this.listStablishments=this.listStablishments.filter(stablishment=>stablishment.id==this.stablishment_id);
            }
            let promiseCate=[];
            this.listStablishments.forEach(stablishment => {
                this.data.push({
                    name:stablishment.name,  
                    stablishment:{...stablishment},
                    categorizations:[],
                    TotalAll:0
                });
                promiseCate.push(
                    new Promise((resolveCat)=>{
                        CategorizationFindByStablishmentId(this.$http,stablishment.id).then(async (responseCat)=>{
                            //find stablishment       
                            let promiseSubcat=[];                          
                            let categorizations = responseCat.map(cat => {
                                return {
                                    ...cat,
                                    subcats: []
                                }
                            });
                            this.data.find(data=>data.stablishment.id==stablishment.id).categorizations.push(...categorizations)
                            //add cat push                                                                     
                            responseCat.forEach(categorization => {                        
                                promiseSubcat.push(
                                    new Promise((resolveSubCate)=>{
                                        SubCategorizationFindByCategorizationId(this.$http,categorization.id).then((responseSubCat)=>{    
                                                let subcategorizations=responseSubCat.map(sub=>{
                                                    return {
                                                        ...sub,
                                                        positives:0,
                                                        negatives:0,
                                                        suspect:0,
                                                        total:0,
                                                    }
                                                })                                                        
                                                this.data.find(data=>data.stablishment.id==stablishment.id).categorizations.find(cat=>cat.id==responseSubCat[0].categorization_id).subcats.push(...subcategorizations);                                                                                                                         
                                                let promiseBed=[]
                                                responseSubCat.forEach(subcat => {
                                                    promiseBed.push(
                                                        new Promise((resolveBed)=>{
                                                            BedFindByStablishmentSubCatId(this.$http,stablishment.id,subcat.id).then((beds)=>{
                                                                let positives=0;
                                                                let negatives= 0;
                                                                let suspect= 0;
                                                                let total= 0 ;    
                                                                beds.forEach(bed => {
                                                                    if (bed.state !== 'HABILITADA' || bed.state1 == "eliminada") {
                                                                        return;
                                                                    }
                                                                    if (bed.covid19 == 'positivo') {
                                                                        positives++;
                                                                    }
                                                                    if (bed.covid19 == 'sospecha') {
                                                                        suspect++;
                                                                    }
                                                                    if (bed.covid19 == 'negativo') {
                                                                        negatives++;
                                                                    }
                                                                    // switch (bed.covid19) {
                                                                    //     case 'positivo':       
                                                                    //         positives++                                                                                               
                                                                    //         break;
                                                                    //     case 'sospecha':
                                                                    //         suspect++
                                                                    //         break
                                                                    //     case 'negativo':
                                                                    //         negatives++
                                                                    //         break;                                                    
                                                                    //     default:                                                    
                                                                    //         break;
                                                                    // }
                                                                });
                                                                total=positives+negatives+suspect;                                                                                                                                
                                                                this.total.positives += positives;                                                                
                                                                this.total.negatives += negatives;
                                                                this.total.suspect += suspect;
                                                                this.total.total +=total
                                                                this.data.find(data=>data.stablishment.id==stablishment.id).categorizations.find(cat=>cat.id==responseSubCat[0].categorization_id).subcats.find(sub=>sub.id==subcat.id).positives=positives;
                                                                this.data.find(data=>data.stablishment.id==stablishment.id).categorizations.find(cat=>cat.id==responseSubCat[0].categorization_id).subcats.find(sub=>sub.id==subcat.id).negatives=negatives;
                                                                this.data.find(data=>data.stablishment.id==stablishment.id).categorizations.find(cat=>cat.id==responseSubCat[0].categorization_id).subcats.find(sub=>sub.id==subcat.id).suspect=suspect;
                                                                this.data.find(data=>data.stablishment.id==stablishment.id).categorizations.find(cat=>cat.id==responseSubCat[0].categorization_id).subcats.find(sub=>sub.id==subcat.id).total=total;
                                                                resolveBed();                      
                                                            });

                                                        })
                                                    )
                                                });   
                                                Promise.all(promiseBed).then(()=>{
                                                    let totalCategory = 0;
                                                    let totalPositivo = 0;
                                                    let totalNegativo = 0;
                                                    let totalSospecha = 0;
                                                    this.data.find(data=>data.stablishment.id==stablishment.id).categorizations.find(cat=>cat.id==responseSubCat[0].categorization_id).subcats.forEach(cat => {
                                                        totalCategory += cat.total;
                                                        totalPositivo += cat.positives;
                                                        totalNegativo += cat.negatives;
                                                        totalSospecha += cat.suspect;
                                                    });
                                                    this.data.find(data=>data.stablishment.id==stablishment.id).categorizations.find(cat=>cat.id==responseSubCat[0].categorization_id).total = totalCategory;
                                                    this.data.find(data=>data.stablishment.id==stablishment.id).categorizations.find(cat=>cat.id==responseSubCat[0].categorization_id).positives = totalPositivo;
                                                    this.data.find(data=>data.stablishment.id==stablishment.id).categorizations.find(cat=>cat.id==responseSubCat[0].categorization_id).negatives = totalNegativo;
                                                    this.data.find(data=>data.stablishment.id==stablishment.id).categorizations.find(cat=>cat.id==responseSubCat[0].categorization_id).suspect = totalSospecha;
                                                    resolveSubCate();
                                                }) 
                                        });              
                                    })
                                )
                            });
                            Promise.all(promiseSubcat).then(()=>{    
                                let totalCategory = 0;
                                let totalPositivo = 0;
                                let totalNegativo = 0;
                                let totalSospecha = 0;
                                this.data.find(data=>data.stablishment.id==stablishment.id).categorizations.forEach(cat => {
                                    totalCategory += cat.total;
                                    totalPositivo += cat.positives;
                                    totalNegativo += cat.negatives;
                                    totalSospecha += cat.suspect;
                                });
                                this.data.find(data=>data.stablishment.id==stablishment.id).total = totalCategory;
                                this.data.find(data=>data.stablishment.id==stablishment.id).positives = totalPositivo;
                                this.data.find(data=>data.stablishment.id==stablishment.id).negatives = totalNegativo;
                                this.data.find(data=>data.stablishment.id==stablishment.id).suspect = totalSospecha; 
                                resolveCat();
                            })
                        });                                
                    })
                )
            });            
            Promise.all(promiseCate).then(()=>{
                this.loading = false;
                eventBus.$emit("emitJsonBedCovidReport", {
                    listStablishments: this.listStablishments,
                    listBeds: this.listBeds,
                    data: this.data,
                    total: this.total, 
                })
            })
        }
    }
}
</script>
<style scoped>
 .col-header {
    background-color: #3c3ebc;
    color: #f0f0f0 !important;
  }
    .col-subheader {
    background-color: #dcdcff !important;
  }
</style>